import { render } from "./DetailsArticle.vue?vue&type=template&id=c2a7de54"
import script from "./DetailsArticle.vue?vue&type=script&lang=js"
export * from "./DetailsArticle.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/article/DetailsArticle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c2a7de54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c2a7de54', __exports__)) {
    console.log('reload')
    api.reload('c2a7de54', __exports__)
  }
  
  module.hot.accept("./DetailsArticle.vue?vue&type=template&id=c2a7de54", () => {
    console.log('re-render')
    api.rerender('c2a7de54', render)
  })

}


export default __exports__